/**
 * @flow
 * @relayHash 316d0afc49c2cbac805a3f1c6a4e6505
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SecondaryNav_document$ref = any;
type TokenAccess_tokens$ref = any;
type commentForm_document$ref = any;
export type Approvable = "NO" | "OPTIONAL" | "REQUIRED" | "%future added value";
export type DocumentStatus = "ACTIVE" | "DELETED" | "OLD" | "OLD_SAVE" | "PENDING" | "RETIRED" | "SAVED" | "SCHEDULED" | "%future added value";
export type ViewPolicyQueryVariables = {|
  documentPk: number,
  showChanges?: ?boolean,
  latest?: ?boolean,
  ignoreLatestRedirect?: ?boolean,
|};
export type ViewPolicyQueryResponse = {|
  +documentView: ?{|
    +document: ?{|
      +id: string,
      +pk: ?number,
      +name: string,
      +html: ?string,
      +author: {|
        +pk: ?number,
        +userDisplay: ?string,
        +firstName: string,
        +lastName: string,
        +profile: ?{|
          +title: ?string
        |},
      |},
      +category: {|
        +pk: ?number,
        +name: string,
      |},
      +bloc: {|
        +id: string,
        +pk: ?number,
        +name: string,
        +tenants: ?$ReadOnlyArray<?{|
          +pk: ?number,
          +name: string,
        |}>,
      |},
      +parent: ?{|
        +id: string
      |},
      +isAForm: boolean,
      +status: ?DocumentStatus,
      +restricted: boolean,
      +effectiveDate: ?string,
      +approvalDate: ?string,
      +expirationDate: ?string,
      +revisionDate: ?string,
      +revisionDates: ?$ReadOnlyArray<?string>,
      +statusChangedDate: ?string,
      +originationDate: ?string,
      +legacyEffectiveDate: ?string,
      +created: ?string,
      +modified: ?any,
      +approvable: Approvable,
      +headerImageUrl: ?string,
      +rssFeedUrl: ?string,
      +rawEffectiveDate: ?string,
      +effectiveDateTimedelta: ?number,
      +actions: ?$ReadOnlyArray<?{|
        +id: string,
        +pk: ?number,
        +actionType: string,
        +actionDate: ?string,
        +comment: string,
        +canEdit: ?boolean,
        +isExternal: boolean,
        +user: ?{|
          +id: string,
          +userDisplay: ?string,
        |},
      |}>,
      +attachments: ?$ReadOnlyArray<?{|
        +title: ?string,
        +fileUrl: ?string,
      |}>,
      +tags: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +approvalWorkflow: ?{|
        +name: ?string,
        +currentStep: ?{|
          +id: string
        |},
        +steps: ?$ReadOnlyArray<?{|
          +id: string,
          +name: ?string,
          +approvers: ?$ReadOnlyArray<?{|
            +firstName: string,
            +lastName: string,
            +isDocumentOwner: ?boolean,
            +hasApproved: ?boolean,
          |}>,
        |}>,
      |},
      +workflowTemplate: ?{|
        +name: ?string,
        +steps: ?$ReadOnlyArray<?{|
          +id: string,
          +includeDocumentOwner: boolean,
          +name: ?string,
          +approvers: ?$ReadOnlyArray<?{|
            +firstName: string,
            +lastName: string,
            +isDocumentOwner: ?boolean,
            +hasApproved: ?boolean,
          |}>,
        |}>,
      |},
      +approvalSignatures: ?$ReadOnlyArray<?{|
        +approver: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +proxySigner: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +approvalStep: ?{|
          +name: ?string
        |},
        +approvedDate: ?string,
        +required: ?boolean,
      |}>,
      +pastApprovalSignatures: ?$ReadOnlyArray<?{|
        +approver: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +proxySigner: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +approvalStep: ?{|
          +name: ?string
        |},
        +approvedDate: ?string,
        +required: ?boolean,
      |}>,
      +regulations: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +onesourceDocuments: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: ?string,
        +viewUrl: ?string,
        +revisionInformation: string,
      |}>,
      +epAssociationDocuments: ?$ReadOnlyArray<?{|
        +pk: ?number
      |}>,
      +draftVersionLink: ?string,
      +pendingVersionLink: ?string,
      +scheduledVersionLink: ?string,
      +isLippincottDocument: ?boolean,
      +linePk: ?number,
      +documentsOfTemplate: ?{|
        +documents: ?$ReadOnlyArray<?{|
          +pk: ?number,
          +bloc: {|
            +pk: ?number,
            +name: string,
          |},
        |}>,
        +systemDocumentTemplate: ?{|
          +bloc: ?{|
            +name: string
          |},
          +document: ?{|
            +pk: ?number
          |},
          +status: ?DocumentStatus,
        |},
      |},
      +isTemplate: ?boolean,
      +systemDocumentTemplateExtension: ?{|
        +pk: ?number
      |},
      +systemDocumentTemplate: ?{|
        +name: ?string,
        +isPublished: ?boolean,
        +isNewVersionAvailable: ?boolean,
        +underReview: ?boolean,
        +expiringInDays: ?number,
      |},
      +hasScheduledTemplate: ?boolean,
      +$fragmentRefs: commentForm_document$ref & SecondaryNav_document$ref,
    |},
    +canCreateReadReceipt: ?boolean,
    +showChanges: ?boolean,
    +showChangesTaskId: ?string,
    +nameChanges: ?string,
    +documentAccessTokens: ?$ReadOnlyArray<?{|
      +$fragmentRefs: TokenAccess_tokens$ref
    |}>,
    +policyActions: ?any,
    +guestAccessLink: ?string,
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
    +tenantsToRedirect: ?$ReadOnlyArray<?{|
      +name: string,
      +url: ?string,
    |}>,
    +redirectUrl: ?string,
    +canEditDocument: ?boolean,
    +showTimeline: ?boolean,
    +lippincottEnabled: ?boolean,
    +documentSave: ?{|
      +pk: ?number
    |},
  |}
|};
export type ViewPolicyQuery = {|
  variables: ViewPolicyQueryVariables,
  response: ViewPolicyQueryResponse,
|};
*/


/*
query ViewPolicyQuery(
  $documentPk: Int!
  $showChanges: Boolean
  $latest: Boolean
  $ignoreLatestRedirect: Boolean
) {
  documentView(pk: $documentPk, showChanges: $showChanges, latest: $latest, ignoreLatestRedirect: $ignoreLatestRedirect) {
    document {
      ...commentForm_document
      ...SecondaryNav_document
      id
      pk
      name
      html
      author {
        pk
        userDisplay
        firstName
        lastName
        profile {
          title
          id
        }
        id
      }
      category {
        pk
        name
        id
      }
      bloc {
        id
        pk
        name
        tenants(sort: "name") {
          pk
          name
          id
        }
      }
      parent {
        id
      }
      isAForm
      status
      restricted
      effectiveDate(formatted: true)
      approvalDate(formatted: true)
      expirationDate(formatted: true)
      revisionDate(formatted: true)
      revisionDates
      statusChangedDate
      originationDate(formatted: true)
      legacyEffectiveDate(formatted: true)
      created
      modified
      approvable
      headerImageUrl
      rssFeedUrl
      rawEffectiveDate: effectiveDate
      effectiveDateTimedelta
      actions(isEditPage: false) {
        id
        pk
        actionType
        actionDate
        comment
        canEdit
        isExternal
        user {
          id
          userDisplay(userDisplayType: FORWARD)
        }
      }
      attachments {
        title
        fileUrl
        id
      }
      tags {
        pk
        name
        id
      }
      approvalWorkflow {
        name
        currentStep {
          id
        }
        steps {
          id
          name
          approvers {
            firstName
            lastName
            isDocumentOwner
            hasApproved
            id
          }
        }
        id
      }
      workflowTemplate {
        name
        steps {
          id
          includeDocumentOwner
          name
          approvers {
            firstName
            lastName
            isDocumentOwner
            hasApproved
            id
          }
        }
        id
      }
      approvalSignatures {
        approver {
          firstName
          lastName
          title
        }
        proxySigner {
          firstName
          lastName
          title
        }
        approvalStep {
          name
          id
        }
        approvedDate(formatted: true)
        required
      }
      pastApprovalSignatures {
        approver {
          firstName
          lastName
          title
        }
        proxySigner {
          firstName
          lastName
          title
        }
        approvalStep {
          name
          id
        }
        approvedDate(formatted: true)
        required
      }
      regulations {
        pk
        name
        id
      }
      onesourceDocuments {
        pk
        name
        viewUrl
        revisionInformation
        id
      }
      epAssociationDocuments {
        pk
        id
      }
      draftVersionLink
      pendingVersionLink
      scheduledVersionLink
      isLippincottDocument
      linePk
      documentsOfTemplate {
        documents {
          pk
          bloc {
            pk
            name
            id
          }
          id
        }
        systemDocumentTemplate {
          bloc {
            name
            id
          }
          document {
            pk
            id
          }
          status
          id
        }
      }
      isTemplate
      systemDocumentTemplateExtension {
        pk
        id
      }
      systemDocumentTemplate {
        name
        isPublished
        isNewVersionAvailable
        underReview
        expiringInDays
        id
      }
      hasScheduledTemplate
    }
    canCreateReadReceipt
    showChanges
    showChangesTaskId
    nameChanges
    documentAccessTokens {
      ...TokenAccess_tokens
      id
    }
    policyActions
    guestAccessLink
    error {
      statusCode
      message
    }
    tenantsToRedirect {
      name
      url
      id
    }
    redirectUrl
    canEditDocument
    showTimeline
    lippincottEnabled
    documentSave {
      pk
      id
    }
  }
}

fragment commentForm_document on DocumentType {
  id
  pk
  canComment
  status
  subscribedToComments
  usersNotificationComment {
    usersNotificationCommentOn {
      pk
      firstName
      lastName
      id
    }
    usersNotificationCommentOff {
      pk
      firstName
      lastName
      id
    }
  }
}

fragment SecondaryNav_document on DocumentType {
  id
  pk
  name
  status
  approvable
  rejectable
  shouldBeAcknowledged
}

fragment TokenAccess_tokens on DocumentAccessTokenType {
  tokenId
  description
  dateLastAccessed
  url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentPk",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "showChanges",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "latest",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ignoreLatestRedirect",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ignoreLatestRedirect",
    "variableName": "ignoreLatestRedirect",
    "type": "Boolean"
  },
  {
    "kind": "Variable",
    "name": "latest",
    "variableName": "latest",
    "type": "Boolean"
  },
  {
    "kind": "Variable",
    "name": "pk",
    "variableName": "documentPk",
    "type": "Int!"
  },
  {
    "kind": "Variable",
    "name": "showChanges",
    "variableName": "showChanges",
    "type": "Boolean"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "html",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userDisplay",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v10 = [
  v3,
  v4
],
v11 = [
  {
    "kind": "Literal",
    "name": "sort",
    "value": "name",
    "type": "String"
  }
],
v12 = [
  v2
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "parent",
  "storageKey": null,
  "args": null,
  "concreteType": "RLDatixDocumentType",
  "plural": false,
  "selections": v12
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAForm",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "formatted",
    "value": true,
    "type": "Boolean"
  }
],
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDate",
  "args": v17,
  "storageKey": "effectiveDate(formatted:true)"
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvalDate",
  "args": v17,
  "storageKey": "approvalDate(formatted:true)"
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": v17,
  "storageKey": "expirationDate(formatted:true)"
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionDate",
  "args": v17,
  "storageKey": "revisionDate(formatted:true)"
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionDates",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "statusChangedDate",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "originationDate",
  "args": v17,
  "storageKey": "originationDate(formatted:true)"
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": v17,
  "storageKey": "legacyEffectiveDate(formatted:true)"
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "modified",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvable",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "headerImageUrl",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rssFeedUrl",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": "rawEffectiveDate",
  "name": "effectiveDate",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDateTimedelta",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "actions",
  "storageKey": "actions(isEditPage:false)",
  "args": [
    {
      "kind": "Literal",
      "name": "isEditPage",
      "value": false,
      "type": "Boolean"
    }
  ],
  "concreteType": "DocumentActionType",
  "plural": true,
  "selections": [
    v2,
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "actionType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "actionDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "comment",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canEdit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isExternal",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "UserType",
      "plural": false,
      "selections": [
        v2,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "userDisplay",
          "args": [
            {
              "kind": "Literal",
              "name": "userDisplayType",
              "value": "FORWARD",
              "type": "UserDisplayType"
            }
          ],
          "storageKey": "userDisplay(userDisplayType:\"FORWARD\")"
        }
      ]
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileUrl",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "currentStep",
  "storageKey": null,
  "args": null,
  "concreteType": "ApprovalStepType",
  "plural": false,
  "selections": v12
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isDocumentOwner",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasApproved",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "approvers",
  "storageKey": null,
  "args": null,
  "concreteType": "ApprovalStepUserType",
  "plural": true,
  "selections": [
    v7,
    v8,
    v36,
    v37
  ]
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "includeDocumentOwner",
  "args": null,
  "storageKey": null
},
v40 = [
  v7,
  v8,
  v9
],
v41 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "approver",
  "storageKey": null,
  "args": null,
  "concreteType": "ApprovalSignatureApproverType",
  "plural": false,
  "selections": v40
},
v42 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "proxySigner",
  "storageKey": null,
  "args": null,
  "concreteType": "ApprovalSignatureApproverType",
  "plural": false,
  "selections": v40
},
v43 = [
  v4
],
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvedDate",
  "args": v17,
  "storageKey": "approvedDate(formatted:true)"
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "required",
  "args": null,
  "storageKey": null
},
v46 = [
  v41,
  v42,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approvalStep",
    "storageKey": null,
    "args": null,
    "concreteType": "ApprovalStepType",
    "plural": false,
    "selections": v43
  },
  v44,
  v45
],
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "viewUrl",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionInformation",
  "args": null,
  "storageKey": null
},
v49 = [
  v3
],
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "draftVersionLink",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pendingVersionLink",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scheduledVersionLink",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isLippincottDocument",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linePk",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isTemplate",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPublished",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isNewVersionAvailable",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "underReview",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expiringInDays",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasScheduledTemplate",
  "args": null,
  "storageKey": null
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canCreateReadReceipt",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showChanges",
  "args": null,
  "storageKey": null
},
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showChangesTaskId",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "nameChanges",
  "args": null,
  "storageKey": null
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "policyActions",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "guestAccessLink",
  "args": null,
  "storageKey": null
},
v67 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v68 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v69 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "redirectUrl",
  "args": null,
  "storageKey": null
},
v70 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canEditDocument",
  "args": null,
  "storageKey": null
},
v71 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showTimeline",
  "args": null,
  "storageKey": null
},
v72 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lippincottEnabled",
  "args": null,
  "storageKey": null
},
v73 = [
  v3,
  v7,
  v8,
  v2
],
v74 = [
  v3,
  v4,
  v2
],
v75 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "approvers",
  "storageKey": null,
  "args": null,
  "concreteType": "ApprovalStepUserType",
  "plural": true,
  "selections": [
    v7,
    v8,
    v36,
    v37,
    v2
  ]
},
v76 = [
  v4,
  v2
],
v77 = [
  v41,
  v42,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approvalStep",
    "storageKey": null,
    "args": null,
    "concreteType": "ApprovalStepType",
    "plural": false,
    "selections": v76
  },
  v44,
  v45
],
v78 = [
  v3,
  v2
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ViewPolicyQuery",
  "id": "08233227824e1bfc867adf60122cfc88",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ViewPolicyQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentView",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentViewType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "commentForm_document",
                "args": null
              },
              {
                "kind": "FragmentSpread",
                "name": "SecondaryNav_document",
                "args": null
              },
              v2,
              v3,
              v4,
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v3,
                  v6,
                  v7,
                  v8,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileType",
                    "plural": false,
                    "selections": [
                      v9
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v10
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  v4,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tenants",
                    "storageKey": "tenants(sort:\"name\")",
                    "args": v11,
                    "concreteType": "TenantType",
                    "plural": true,
                    "selections": v10
                  }
                ]
              },
              v13,
              v14,
              v15,
              v16,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v25,
              v26,
              v27,
              v28,
              v29,
              v30,
              v31,
              v32,
              v33,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "attachments",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentAttachmentType",
                "plural": true,
                "selections": [
                  v9,
                  v34
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v10
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approvalWorkflow",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": [
                  v4,
                  v35,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "steps",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ApprovalStepType",
                    "plural": true,
                    "selections": [
                      v2,
                      v4,
                      v38
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workflowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": [
                  v4,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "steps",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ApprovalStepType",
                    "plural": true,
                    "selections": [
                      v2,
                      v39,
                      v4,
                      v38
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approvalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v46
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pastApprovalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v46
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regulations",
                "storageKey": null,
                "args": null,
                "concreteType": "RegulationType",
                "plural": true,
                "selections": v10
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v3,
                  v4,
                  v47,
                  v48
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "epAssociationDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "EpAssociationDocumentType",
                "plural": true,
                "selections": v49
              },
              v50,
              v51,
              v52,
              v53,
              v54,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "documentsOfTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentsOfTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "documents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": true,
                    "selections": [
                      v3,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v10
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "systemDocumentTemplate",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v43
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": v49
                      },
                      v15
                    ]
                  }
                ]
              },
              v55,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplateExtension",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v49
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": [
                  v4,
                  v56,
                  v57,
                  v58,
                  v59
                ]
              },
              v60
            ]
          },
          v61,
          v62,
          v63,
          v64,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentAccessTokens",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentAccessTokenType",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "TokenAccess_tokens",
                "args": null
              }
            ]
          },
          v65,
          v66,
          v67,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v4,
              v68
            ]
          },
          v69,
          v70,
          v71,
          v72,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentSave",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentSaveType",
            "plural": false,
            "selections": v49
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ViewPolicyQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentView",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentViewType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canComment",
                "args": null,
                "storageKey": null
              },
              v15,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subscribedToComments",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "usersNotificationComment",
                "storageKey": null,
                "args": null,
                "concreteType": "UserCommentNotificationType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOn",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v73
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOff",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v73
                  }
                ]
              },
              v4,
              v28,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rejectable",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shouldBeAcknowledged",
                "args": null,
                "storageKey": null
              },
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v3,
                  v6,
                  v7,
                  v8,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileType",
                    "plural": false,
                    "selections": [
                      v9,
                      v2
                    ]
                  },
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v74
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  v4,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tenants",
                    "storageKey": "tenants(sort:\"name\")",
                    "args": v11,
                    "concreteType": "TenantType",
                    "plural": true,
                    "selections": v74
                  }
                ]
              },
              v13,
              v14,
              v16,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v25,
              v26,
              v27,
              v29,
              v30,
              v31,
              v32,
              v33,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "attachments",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentAttachmentType",
                "plural": true,
                "selections": [
                  v9,
                  v34,
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v74
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approvalWorkflow",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": [
                  v4,
                  v35,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "steps",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ApprovalStepType",
                    "plural": true,
                    "selections": [
                      v2,
                      v4,
                      v75
                    ]
                  },
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workflowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": [
                  v4,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "steps",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ApprovalStepType",
                    "plural": true,
                    "selections": [
                      v2,
                      v39,
                      v4,
                      v75
                    ]
                  },
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approvalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v77
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pastApprovalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v77
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regulations",
                "storageKey": null,
                "args": null,
                "concreteType": "RegulationType",
                "plural": true,
                "selections": v74
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v3,
                  v4,
                  v47,
                  v48,
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "epAssociationDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "EpAssociationDocumentType",
                "plural": true,
                "selections": v78
              },
              v50,
              v51,
              v52,
              v53,
              v54,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "documentsOfTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentsOfTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "documents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": true,
                    "selections": [
                      v3,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v74
                      },
                      v2
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "systemDocumentTemplate",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v76
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": v78
                      },
                      v15,
                      v2
                    ]
                  }
                ]
              },
              v55,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplateExtension",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v78
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": [
                  v4,
                  v56,
                  v57,
                  v58,
                  v59,
                  v2
                ]
              },
              v60
            ]
          },
          v61,
          v62,
          v63,
          v64,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentAccessTokens",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentAccessTokenType",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "tokenId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dateLastAccessed",
                "args": null,
                "storageKey": null
              },
              v68,
              v2
            ]
          },
          v65,
          v66,
          v67,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v4,
              v68,
              v2
            ]
          },
          v69,
          v70,
          v71,
          v72,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentSave",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentSaveType",
            "plural": false,
            "selections": v78
          }
        ]
      }
    ]
  }
};
})();
node.text = "query ViewPolicyQuery(\n  $documentPk: Int!\n  $showChanges: Boolean\n  $latest: Boolean\n  $ignoreLatestRedirect: Boolean\n) {\n  documentView(pk: $documentPk, showChanges: $showChanges, latest: $latest, ignoreLatestRedirect: $ignoreLatestRedirect) {\n    document {\n      ...commentForm_document\n      ...SecondaryNav_document\n      id\n      pk\n      name\n      html\n      author {\n        pk\n        userDisplay\n        firstName\n        lastName\n        profile {\n          title\n          id\n        }\n        id\n      }\n      category {\n        pk\n        name\n        id\n      }\n      bloc {\n        id\n        pk\n        name\n        tenants(sort: \"name\") {\n          pk\n          name\n          id\n        }\n      }\n      parent {\n        id\n      }\n      isAForm\n      status\n      restricted\n      effectiveDate(formatted: true)\n      approvalDate(formatted: true)\n      expirationDate(formatted: true)\n      revisionDate(formatted: true)\n      revisionDates\n      statusChangedDate\n      originationDate(formatted: true)\n      legacyEffectiveDate(formatted: true)\n      created\n      modified\n      approvable\n      headerImageUrl\n      rssFeedUrl\n      rawEffectiveDate: effectiveDate\n      effectiveDateTimedelta\n      actions(isEditPage: false) {\n        id\n        pk\n        actionType\n        actionDate\n        comment\n        canEdit\n        isExternal\n        user {\n          id\n          userDisplay(userDisplayType: FORWARD)\n        }\n      }\n      attachments {\n        title\n        fileUrl\n        id\n      }\n      tags {\n        pk\n        name\n        id\n      }\n      approvalWorkflow {\n        name\n        currentStep {\n          id\n        }\n        steps {\n          id\n          name\n          approvers {\n            firstName\n            lastName\n            isDocumentOwner\n            hasApproved\n            id\n          }\n        }\n        id\n      }\n      workflowTemplate {\n        name\n        steps {\n          id\n          includeDocumentOwner\n          name\n          approvers {\n            firstName\n            lastName\n            isDocumentOwner\n            hasApproved\n            id\n          }\n        }\n        id\n      }\n      approvalSignatures {\n        approver {\n          firstName\n          lastName\n          title\n        }\n        proxySigner {\n          firstName\n          lastName\n          title\n        }\n        approvalStep {\n          name\n          id\n        }\n        approvedDate(formatted: true)\n        required\n      }\n      pastApprovalSignatures {\n        approver {\n          firstName\n          lastName\n          title\n        }\n        proxySigner {\n          firstName\n          lastName\n          title\n        }\n        approvalStep {\n          name\n          id\n        }\n        approvedDate(formatted: true)\n        required\n      }\n      regulations {\n        pk\n        name\n        id\n      }\n      onesourceDocuments {\n        pk\n        name\n        viewUrl\n        revisionInformation\n        id\n      }\n      epAssociationDocuments {\n        pk\n        id\n      }\n      draftVersionLink\n      pendingVersionLink\n      scheduledVersionLink\n      isLippincottDocument\n      linePk\n      documentsOfTemplate {\n        documents {\n          pk\n          bloc {\n            pk\n            name\n            id\n          }\n          id\n        }\n        systemDocumentTemplate {\n          bloc {\n            name\n            id\n          }\n          document {\n            pk\n            id\n          }\n          status\n          id\n        }\n      }\n      isTemplate\n      systemDocumentTemplateExtension {\n        pk\n        id\n      }\n      systemDocumentTemplate {\n        name\n        isPublished\n        isNewVersionAvailable\n        underReview\n        expiringInDays\n        id\n      }\n      hasScheduledTemplate\n    }\n    canCreateReadReceipt\n    showChanges\n    showChangesTaskId\n    nameChanges\n    documentAccessTokens {\n      ...TokenAccess_tokens\n      id\n    }\n    policyActions\n    guestAccessLink\n    error {\n      statusCode\n      message\n    }\n    tenantsToRedirect {\n      name\n      url\n      id\n    }\n    redirectUrl\n    canEditDocument\n    showTimeline\n    lippincottEnabled\n    documentSave {\n      pk\n      id\n    }\n  }\n}\n\nfragment commentForm_document on DocumentType {\n  id\n  pk\n  canComment\n  status\n  subscribedToComments\n  usersNotificationComment {\n    usersNotificationCommentOn {\n      pk\n      firstName\n      lastName\n      id\n    }\n    usersNotificationCommentOff {\n      pk\n      firstName\n      lastName\n      id\n    }\n  }\n}\n\nfragment SecondaryNav_document on DocumentType {\n  id\n  pk\n  name\n  status\n  approvable\n  rejectable\n  shouldBeAcknowledged\n}\n\nfragment TokenAccess_tokens on DocumentAccessTokenType {\n  tokenId\n  description\n  dateLastAccessed\n  url\n}\n";
(node/*: any*/).hash = '4071516c6cb66335538cba968e5eb7ec';
module.exports = node;
